<script lang="ts">
  const {value} = $props()
</script>

<span class="link-content">
  #{value}
</span>
